export const news = {
  newsFeedCreateInputPlaceholder: 'Napisz post...',
  newsFeedSearchInputPlaceholder: 'Szukaj',
  newsFeedPostOwnerCurtainEditTitle: 'Edytuj post',
  newsFeedPostOwnerCurtainDeleteTitle: 'Usuń post',
  newsFeedEditedPostSavedAlertText: 'Post został zapisany!',
  newsFeedEditedPostDeletedAlertText: 'Post został usunięty!',
  newsFeedShareCurtainOptionTitle: 'Skopiuj link',
  newsFeedPostLinkCopiedAlertText: 'Link został skopiowany!',
  newsFeedOthersPostCurtainOptionCopyTitle: 'Skopiuj link',
  newsFeedOthersPosLinkCopiedAlertText: 'Link został skopiowany!',
  newsFeedOthersPostCurtainOptionFlagTitle: 'Zgłoś treść',
  newsFeedOtherPostOwnersCurtainDeleteTitle: 'Usuń post',
  newsFeedPostDeletePopupTitle: 'Usuń',
  newsFeedPostDeletePopupText: 'Czy na pewno chcesz usunąć ten post?',
  newsFeedPostDeletePopupCancelButtonTitle: 'Anuluj',
  newsFeedPostDeletePopupConfirmButtonTitle: 'Potwierdź',
  newsFeedPostDeeletedAlertText: 'Post został usunięty!',
  newsPostDetailsHeaderTitle: 'Post',
  postFeedPostLikesText: 'Lubię to',
  postFeedPostCommentsText: 'Komentarze',
  postFeedPostNoLikesText: 'Brak polubień',
  postFeedPostLeaveFirstLikeText: 'Możesz być pierwszym, który polubi ten post',
  newsFeedPostDetailsNoCommentsText: 'Brak komentarzy',
  newsFeedPostDetailsFirstCommentText: 'Możesz być pierwszym, który zostawi komentarz',
  newsFeedPostDetailsShareOptionTitle: 'Skopiuj link',
  newsFeedPostDetailsSharePostCopiedAlertText: 'Link został skopiowany!',
  newsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Skopiuj link',
  newsFeedPostDetailsCopiedAlertText: 'Link został skopiowany!',
  newsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Zgłoś treść',
  newsPostDetailsFlagCurtainOptionSpamTitle: 'Zgłoś',
  newsPostDetailsReportedCurtainText: 'Treść została zgłoszona',
  newsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Edytuj komentarz',
  newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Usuń komentarz',
  newsPostDetailsEditedCommentSavedAlertText: 'Komentarz został zapisany!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Usuń komentarz',
  postDetailsOtherUsersCommentDeletadAlertText: 'Komentarz został usunięty!',
  postDetailsDeleteCommentPopupTitle: 'Usuń',
  postDetailsDeleteCommentPopupText: 'Czy na pewno chcesz usunąć ten komentarz?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Anuluj',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Potwierdź',
  postDetailsCommDeletedAlertText: 'Komentarz został usunięty!',
  postDetailsCommentUserCurtainOptionTitle: 'Zgłoś komentarz',
  newsCreatePostCurtainTitle: 'Nowy post',
  newsCreatePostCurtainBodyPlaceholder: 'Wpisz treść tutaj...',
  newsCreatePostPublishButtonTitle: 'Opublikuj',
  newsCreatePostUploadSlallerImageAlertText: 'Możesz przesłać maksymalnie {size} MB naraz',
  newsPostSavedAlertText: 'Post został zapisany!',
  newsCreatePostAddLocationCurtainTitle: 'Lokalizacja',
  newsCreatePostAddLocationCurtainInputPlaceholder: 'Nazwa lokalizacji',
  newsCreatePostEditLocationCurtainText: 'Edytuj lokalizację',
  newsDeleteLocation: 'Usuń lokalizację',
  newsDiscardPostPopupTitle: 'Szkic',
  newsDiscardPostPopupText: 'Czy na pewno chcesz porzucić ten szkic?',
  newsDiscardPostPopupCancelButtonTitle: 'Anuluj',
  newsDiscardPostPopupCofirmButtonTitle: 'Potwierdź',
  newsNewPostCreatePollTitle: 'Utwórz ankietę',
  newsNewPostCreatePollTitleInputPlaceholder: 'Tytuł',
  newsNewPostCreatePollOptionInputPlaceholder: 'Opcja',
  newsNewPostCreatePollAddButtonTitle: 'Dodaj opcję',
  newsNewPostCreatePollCreateButtonTitle: 'Utwórz',
  newsCreatePostPollTitleBlankAlertText: 'Tytuł nie może być pusty!',
  newsCreatePostPollOptionBlankAlertText: 'Opcja nie może być pusta!',
  newsCreatePostPollLongTitleAlertText: 'Tytuł może zawierać maksymalnie {length} znaków',
  newsCreatePostPollLongOptionAlertText: 'Opcja może zawierać maksymalnie {length} znaków',
  newsCreatePostPollEditOptionTitle: 'Edytuj ankietę',
  newsCreatePostPollRemoveOptionTitle: 'Usuń ankietę',
  newsPostPollInfoVotesText: 'głosy',
  newsPostPollInfoEditVoteText: 'Edytuj głos',
  newsPostPollFinishPollText: 'Zakończ ankietę',
  newsPostPollFinishedPollText: 'Zakończono',
  newsPostPollInProgresslText: 'W trakcie',
  newsFinishPollCurtainTitle: 'Zakończ ankietę',
  newsFinishPollCurtainText: 'Użytkownicy nie będą mogli głosować po zakończeniu ankiety.',
  newsFinishPollCurtainCancelButtonTitle: 'Anuluj',
  newsFinishPollCurtainConfirmlButtonTitle: 'Potwierdź',
  newsPollInfoPollVotesCurtainTitle: 'Wyniki ankiety',
  newsEditPostCurtainTitle: 'Edytuj post',
  newsEditPostCurtainNoTextBodyPlaceholder: 'Wpisz treść tutaj...',
  newsEditPostCurtainSaveButtonTitle: 'Zapisz',
  newsEditPostSavedAlertText: 'Post został zapisany!',
  newsError: 'Coś poszło nie tak!',
  newsAt: 'o',
  newsSeeMore: 'Zobacz więcej...',
  newsMaxAttachments: 'Przekroczyłeś maksymalną liczbę załączników. Maksymalna liczba załączników to {length}',
  newsReply: 'Odpowiedz',
  newsPin: 'Przypnij post',
  newsUnpin: 'Odepnij post'
}
